import * as actions from '../actions/tooltip';

const initialState = {
  tooltipData: null,
  eventData: null,
  isShowing: false,
  position: null,
  isOverTooltip: false,
  isLoading: false,
  isFavorite: false,
};

export default function newTooltip(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_AND_SHOW_TOOLTIP:
      return {
        tooltipData: { ...action.tooltipData },
        isFavorite: action.isFavorite,
        eventData: { ...action.eventData },
        position: { ...action.position },
        isShowing: true,
        isLoading: false,
        isOverTooltip: false,
      };
    case actions.OVER_TOOLTIP:
      return { ...state, isShowing: true, isOverTooltip: true };
    case actions.ON_MOUSE_LEAVE_TOOLTIP:
      return { ...initialState };
    case actions.DELETE_TOOLTIP:
      return { ...initialState };
    case actions.FAVORITE_REQUEST_INIT:
      return { ...state, isLoading: true };
    case actions.FAVORITE_REQUEST_SUCCESS:
      return { ...state, isLoading: false };
    case actions.TOOGLE_IS_FAVORITE:
      return { ...state, isFavorite: !state.isFavorite };
    default:
      return state;
  }
}
